import { PlanningProgress } from "@providers/hop-ord-server/api";

export const AutomationStatus = {
  SUCCESS: "success",
  ERROR: "error",
  IN_PROGRESS: "in_progress",
  NOT_STARTED: "not_started",
} as const;

export type AutomationStatus =
  (typeof AutomationStatus)[keyof typeof AutomationStatus];

export const getElapsedTimeSubtext = (status: AutomationStatus): string => {
  switch (status) {
    case AutomationStatus.SUCCESS:
      return "Completed | Elapsed time:";
    case AutomationStatus.ERROR:
      return "Failed | Elapsed time:";
    case AutomationStatus.NOT_STARTED:
      return "Queued";
    default:
      return "Processing | Elapsed time:";
  }
};

export const getPlanProgressPercentage = (
  stepSequence: string[],
  step: string,
) => {
  const stepIndex = stepSequence.indexOf(step);
  if (stepIndex === -1) {
    return 0;
  }
  return ((stepIndex + 1) / stepSequence.length) * 100;
};

export const getStatusColour = (status: AutomationStatus) => {
  if (status === AutomationStatus.SUCCESS) {
    return "success";
  }

  if (status === AutomationStatus.ERROR) {
    return "error";
  }

  if (status === AutomationStatus.IN_PROGRESS) {
    return "secondary";
  }

  return "inherit";
};

export const getAutomationStatus = (
  progress?: PlanningProgress,
): AutomationStatus => {
  if (progress?.result?.success) {
    return AutomationStatus.SUCCESS;
  }
  if (progress?.result?.error) {
    return AutomationStatus.ERROR;
  }
  if (progress?.planningStartedAt) {
    return AutomationStatus.IN_PROGRESS;
  }
  return AutomationStatus.NOT_STARTED;
};
